import { render, staticRenderFns } from "./commonMenuTemplateManage.vue?vue&type=template&id=4de835d7&scoped=true"
import script from "./commonMenuTemplateManage.vue?vue&type=script&lang=js"
export * from "./commonMenuTemplateManage.vue?vue&type=script&lang=js"
import style0 from "./commonMenuTemplateManage.vue?vue&type=style&index=0&id=4de835d7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de835d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de835d7')) {
      api.createRecord('4de835d7', component.options)
    } else {
      api.reload('4de835d7', component.options)
    }
    module.hot.accept("./commonMenuTemplateManage.vue?vue&type=template&id=4de835d7&scoped=true", function () {
      api.rerender('4de835d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/menuTemplateManage/commonMenuTemplateManage.vue"
export default component.exports